import React from 'react';
import { Link } from 'react-router-dom';
import aThirdHit from './images/a-third-hit/231023_a third hit small.jpg';
import inTheWindsOfTime from './images/251102_in the winds of time.jpg'
import oneImage from './images/a-third-hit-1.jpg';
import twoImage from './images/a-third-hit-2.jpg';
import thirdImage from './images/a-third-hit-3.jpg';
import fourImage from './images/a-third-hit-4.jpg';
import fiveImage from './images/a-third-hit-5.jpg';
import aThirdHitTitle from './images/a third hit animated title.gif'
import title from './images/a third hit animated title.gif';

import './App.css';

class App extends React.Component {
    state = {
        passwordField: ""
    };

    render () {
        return (
            <>
            <div className="App">
                <header className="App-header">
                        <Link
                            to="/NothingDrawsNearer"
                            className=""
                            style={{
                                marginTop: "10px",
                                // textDecorationLine: "none",
                                fontSize: "15px",
                                color: "#61dafb",
                                animation: "rainbow 2.5s linear reverse",
                                animationIterationCount: "infinite"
                            }}
                        >
                            nothing draws nearer<span 
                            style={{
                                textDecorationLine: "none",
                                fontSize: "15px",
                                color: "#000"
                            }}></span>
                        </Link>
                    <div
                        style={
                            {height: "100px"}
                        }
                    >
                    </div>
                </header>
            </div>
            </>
        );
    }
}

export default App;
